var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-selector" },
    [
      _c("div", { staticClass: "event-selector-toolbar" }, [
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("automation.automationName")) + ": "),
            ]),
            _vm._v(" "),
            _c("a-input", {
              attrs: { placeholder: _vm.$t("automation.automationName") },
              model: {
                value: _vm.automationName,
                callback: function ($$v) {
                  _vm.automationName = $$v
                },
                expression: "automationName",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "module-chips" },
        _vm._l(_vm.modules, function (module) {
          return _c(
            "div",
            {
              key: module,
              class: ["module-chip", { active: _vm.selectedModule === module }],
              on: {
                click: function ($event) {
                  _vm.selectedModule = module
                },
              },
            },
            [
              _vm.getModuleIcon(module).antIcon
                ? _c("a-icon", {
                    staticClass: "chip-icon",
                    attrs: { type: _vm.getModuleIcon(module).antIcon },
                  })
                : _vm.getModuleIcon(module).materialIcon
                ? _c("i", { staticClass: "material-icons chip-icon" }, [
                    _vm._v(_vm._s(_vm.getModuleIcon(module).materialIcon)),
                  ])
                : _vm.getModuleIcon(module).customIcon
                ? _c(_vm.getModuleIcon(module).customIcon, {
                    tag: "component",
                    staticClass: "chip-icon custom-icon",
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "chip-text" }, [
                _vm._v(_vm._s(_vm.getModuleDisplayName(module))),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("SupsisTable", {
        attrs: {
          columns: _vm.getCols(),
          rows: _vm.getEvents(),
          "top-pagination": "",
          "empty-data-bordered": "",
          "bottom-pagination": "",
          "pagination-cursor": _vm.pagination,
          options: {
            checkboxOption: _vm.checkboxOption,
            rowStyleOption: _vm.rowStyleOption,
            clipboardOption: _vm.clipboardOption,
            fixedHeader: true,
            id: "events-table",
            borderX: true,
            borderY: true,
          },
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.pagination = cursor)
          },
        },
      }),
      _vm._v(" "),
      _c("MessageMatchedConfig", {
        attrs: {
          visible: _vm.showMessageMatchedConfigModal,
          "ok-text": _vm.$t("settings.create"),
          "cancel-text": _vm.$t("message.cancelText"),
        },
        on: {
          save: _vm.saveMessageMatchedConfig,
          cancel: _vm.cancelMessageMatchedConfig,
        },
        model: {
          value: _vm.messageMatchedConfig,
          callback: function ($$v) {
            _vm.messageMatchedConfig = $$v
          },
          expression: "messageMatchedConfig",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }